import { editCopiedPhysiciansOptions } from '@generated';
import { PhysicianRowLabel } from './PhysicianRowLabel';
import { OrderItems } from '../OrderItems';
import { OrderPhysiciansFormModal } from './OrderPhysiciansFormModal';
import { SectionListRow } from '~/shared/section/section-list/SectionListRow';
import { useFullOrder } from '../orders/FullOrderContext';

export function CopiedPhysicians() {
	const { fullOrder } = useFullOrder();
	return (
		<OrderItems
			title="Copied Physicians"
			items={fullOrder.copiedPhysicians.map(e => (
				<SectionListRow key={e.patientPhysicianId} label={<PhysicianRowLabel patientPhysician={e.patientPhysician} notes={e.notes} />} />
			))}
			sectionButtonProps={{
				useSuspense: true,
				renderModal: closeModal => (
					<OrderPhysiciansFormModal
						title="Copied Physicians"
						order={fullOrder}
						currentPhysicians={fullOrder.copiedPhysicians}
						filterEligible={p => p.id !== fullOrder.orderingPatientPhysicianId}
						saveMutation={editCopiedPhysiciansOptions}
						commandListKey="copiedPatientPhysicians"
						closeModal={closeModal}
					/>
				)
			}}
		/>
	);
}
